<template>
  <div class="app-container">
    <!-- 主要内容区域 -->

    <div class="main-content">
      <div class="bgk-img">
        <img src="https://www.hketang.cn/_nuxt/img/course-banner.2811f9b.png" alt="" />
      </div>

      <div class="tabs-box">
        <div class="title-box">师资团队</div>

        <div class="listbox">
          <div class="ul-item">
            <div class="li-item" v-for="(item, index) in teamlist" :key="index">
              <img :src="item.avatar" alt="" class="team-img" />

              <div class="info">
                <div class="name">{{ item.name }}</div>

                <div class="introduce">{{ item.introInfo }}</div>
              </div>

              <div class="absolute">
                <div class="absolutename">{{ item.name }}</div>

                <div class="absolutetitle">讲师介绍</div>

                <div class="absoluteInfo">
                  {{ item.introDetail }}
                </div>
              </div>
            </div>
            <div style="width: 268px"></div>

            <div style="width: 268px"></div>

            <div style="width: 268px"></div>
          </div>

          <el-pagination
            style="text-align: right"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="pagesize"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getteachers } from "@/api/index.js";
export default {
  name: "team",
  components: {},
  data() {
    return {
      teamlist: [],
      currentPage: 1,
      pagesize: 12,
      total: 0,
    };
  },
  created() {
    this.getteachers();
  },
  methods: {
    getteachers() {
      getteachers({
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        // homePageViewd: true  // 只获取首页展示的教师
      }).then((res) => {
        if (res.data && res.data.list) {
          this.teamlist = res.data.list;
          this.total = res.data.total || 0;
        } else {
          this.teamlist = [];
          this.total = 0;
        }
      }).catch(error => {
        console.error('获取教师信息失败:', error);
        this.teamlist = [];
        this.total = 0;
      }); 
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.currentPage = 1; // 改变页面大小时重置页码
      this.getteachers(); 
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getteachers(); 
    },
  },
};
</script>

<style scoped lang="scss">
.app-container {
  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei";
  color: #333;
  overflow: hidden;
  clear: both;
  .main-content {
    overflow: visible;
    position: relative;
    background: #f5f6f9;
    .bgk-img {
      width: 100%;
      height: 210px;
      z-index: 2;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .tabs-box {
      width: 100%;
      padding: 0 0 60px 0;
      position: relative;
      z-index: 100;
      overflow: visible;
      .title-box {
        background: #fff;
        border-radius: 20px 20px 0 0;
        width: 1200px; // margin: -40px auto;
        font-size: 36px;
        color: #2d3341;
        font-weight: 700;
        font-family: "Microsoft YaHei";
        line-height: 1.1;
        margin-bottom: 24px;
        margin: -50px auto;
        padding-top: 74px;
        position: relative;
        z-index: 3;
      }
      .listbox {
        width: 1140px;
        margin: 20px auto;
        background: #fff;

        padding: 30px;
        .ul-item {
          display: flex;
          cursor: pointer;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 54px;
          .li-item {
            overflow: hidden;
            width: 250px;
            height: 345px;
            margin: 0 0 20px 0;
            background-color: #fff;
            color: #fff;
            text-align: center;
            border-radius: 10px;
            position: relative;
            box-shadow: 0 0.125rem 0.3125rem rgba(0, 0, 0, 0.1);
            img {
              width: 250px;
              height: 345px;
              object-fit: cover;
            }
            .info {
              position: absolute;
              bottom: 0;
              width: 210px;
              background-color: #fff;
              padding: 12px 20px;
              transition: transform 0.3s ease-in-out;
              .name {
                color: #000;
                font-size: 24px;
              }
              .introduce {
                color: #ed8a42;
                font-size: 14px;
                margin: 15px 0 5px 0;
              }
            }
            &:hover .info {
              transform: translateY(100%);
            }
            .absolute {
              display: none;
              position: absolute;
              top: 0;
              left: 0;
              /* width: 250px; */
              /* height: 345px; */
              width: 210px;
              height: 295px;
              padding: 30px 20px 20px 20px;
              text-align: left;
              background-color: rgba(0, 0, 0, 0.1);
              font-family: Microsoft YaHei;
              .absolutename {
                color: #fff;
                font-size: 22px;
                font-weight: 700;
              }
              .absolutetitle {
                color: #fff;
                font-size: 16px;
                margin: 30px 0 10px;
              }
              .absoluteInfo {
                color: #fff;
                font-size: 14px;
                height: 158px;
                overflow-y: scroll;
                padding-right: 20px;
                box-sizing: content-box;
                width: calc(100% + 20px);
              }
            }
            &:hover .absolute {
              display: block;
            }
          }
        }
      }
    }
  }
}

/* ====== Mobile responsive overrides for Team page ====== */
@media (max-width: 1200px) {
  .app-container .main-content .tabs-box .title-box {
    width: auto;
    margin: 0;
    margin-top: -50px;
    padding: 74px 16px 0;
  }
  .app-container .main-content .tabs-box .listbox {
    width: auto;
    margin: 20px 16px;
    padding: 16px;
  }
}

@media (max-width: 992px) {
  .app-container .main-content .tabs-box .listbox .ul-item {
    justify-content: center;
    gap: 12px;
  }
  .app-container .main-content .tabs-box .listbox .ul-item .li-item {
    width: calc(50% - 6px);
    height: auto;
  }
  .app-container .main-content .tabs-box .listbox .ul-item .li-item img {
    width: 100%;
    height: auto;
  }
  .app-container .main-content .tabs-box .listbox .ul-item > div[style*="width: 268px"] {
    display: none;
  }
}

@media (max-width: 600px) {
  .app-container .main-content .tabs-box .listbox .ul-item .li-item {
    width: 100%;
  }
}
</style>
